import IntegrationGrid from '../components/IntegrationGrid';
import ProjectContextBadge from '../components/layout/ProjectContextBadge';
import ProjectSwitcher from '../components/layout/ProjectSwitcher';
import useProjectStore from '../stores/projectStore';

export default function Integrations() {
  const currentProjectId = useProjectStore((s) => s.currentProjectId);

  return (
    <div className="p-4 lg:p-6 max-w-6xl mx-auto">
      <ProjectContextBadge />
      <div className="flex items-start justify-between gap-4 mb-5 flex-wrap">
        <div>
          <h1 className="text-[22px] font-semibold tracking-tight text-[#0D3B50]">Anbindungen</h1>
          <p className="text-[13.5px] text-gray-500 mt-1 max-w-xl">
            Verbinde Search Console, GA4, Google Ads und den OptimusAI-Tracker mit diesem Projekt.
            Jede Anbindung schaltet die zugehörigen Funktionen in der Sidebar frei.
          </p>
        </div>
      </div>

      {!currentProjectId ? (
        <div className="bg-white rounded-xl shadow-sm border border-black/[.07] p-6 text-center">
          <div className="text-[14px] text-gray-600 mb-3">
            Wähle ein Projekt, um dessen Anbindungen zu verwalten.
          </div>
          <div className="inline-block">
            <ProjectSwitcher />
          </div>
        </div>
      ) : (
        <IntegrationGrid projectId={currentProjectId} />
      )}
    </div>
  );
}
